import { Component, Input } from '@angular/core';

@Component({
  selector: 'panel',
  templateUrl: './panel.component.html',
  styleUrls: []
})
export class Panel {
  @Input() header: string ='This is header'; 
  @Input() footer: string ='Więcej';  
  @Input() footerColor: string = 'transparent';
  @Input() link: string;

  
  _footerPos: string ='start';

  @Input('footerPos')
  set in(val) {
    this._footerPos = 'flex-' + val;
  } 
}